import { render, staticRenderFns } from "./BusiestDay.vue?vue&type=template&id=72bce62f&"
import script from "./BusiestDay.vue?vue&type=script&lang=js&"
export * from "./BusiestDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports